import React from 'react';
import {Modal} from 'react-bootstrap'
import '../css sheets/footer.css'
import {
  MDBFooter,
  MDBContainer,
  MDBCol,
  MDBRow,
  MDBIcon
} from 'mdb-react-ui-kit';
import { BsLinkedin } from "react-icons/bs";
import { AiOutlineFacebook } from "react-icons/ai";
import { VscGithub } from "react-icons/vsc";
import { SiUpwork } from "react-icons/si";
import { AiOutlineMail } from "react-icons/ai";
import { FiInstagram } from "react-icons/fi";


   
 function Footer() {
    

    function Email_contact() {
        const [lgShow, setLgShow] = React.useState(false);
        return (
        <>
            <AiOutlineMail onClick={() => setLgShow(true)} className='contact_icon'/>
            <Modal
            size="md"
            show={lgShow}
            onHide={() => setLgShow(false)}
            aria-labelledby="example-modal-sizes-title-lg"
            dialogClassName="custom-modal-dialog" 
            >
            <Modal.Header closeButton>
                <Modal.Title id="example-modal-sizes-title-lg">
                MY GMAIL
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                atdd1929@gmail.com
            </Modal.Body>
            </Modal>
        </>
        );
    }



    return (
        <MDBFooter className='app-footer' >
        <MDBContainer className='p-4 pb-0'>
            <h4>CONTACT ME</h4>
            <section className='mb-4'>
            <a target="blank" className='btn btn-outline-light btn-floating m-1' href='https://www.linkedin.com/in/andrew-thomas-864320201/' role='button'>
                <BsLinkedin className='contact_icon'/>
            </a>

            <a target="blank" className='btn btn-outline-light btn-floating m-1' href='https://www.facebook.com/AndrewThomas1995/' role='button'>
                <AiOutlineFacebook className='contact_icon'/>
            </a>

            <a target="blank" className='btn btn-outline-light btn-floating m-1' href='https://github.com/DrewsClues' role='button'>
                <VscGithub className='contact_icon'/>
            </a>
            <a target="blank" className='btn btn-outline-light btn-floating m-1' href='https://www.upwork.com/freelancers/~014b00e86231d8691b' role='button'>
                <SiUpwork className='contact_icon'/>
            </a>

            <a className='btn btn-outline-light btn-floating m-1' role='button'>
                <Email_contact className='contact_icon'/>
            </a>
            </section>
        </MDBContainer>
        </MDBFooter>
    );
    }

export default Footer;